import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

var firebaseConfig = {
    apiKey: "AIzaSyCIv2IO1zvYsbIf4fvLB4WWdV4-Ft_FdE8",
    authDomain: "merkdev-ae915.firebaseapp.com",
    databaseURL: "https://merkdev-ae915.firebaseio.com",
    projectId: "merkdev-ae915",
    storageBucket: "merkdev-ae915.appspot.com",
    messagingSenderId: "339275270363",
    appId: "1:339275270363:web:db08268541294fcb"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  const firestore = firebase.firestore()
  export const storage = firebase.storage()
  

  export default firestore 